import React from "react"

// Tiny bar sparkline from a normalised series (values 0..1). Pure CSS bars, no
// chart dependency. Used in the growth strip.
export function Sparkbars({ spark = [] }) {
  if (spark.length === 0) return <div className="h-10" />

  return (
    <div className="flex h-10 items-end gap-1" aria-hidden="true">
      {spark.map((v, i) => (
        <span
          key={i}
          className="flex-1 rounded-sm bg-indigo-300"
          style={{ height: `${Math.max(8, (v || 0) * 100)}%` }}
        />
      ))}
    </div>
  )
}

// A growth metric: count, week delta, and a sparkline. Three of these sit side
// by side with the efficiency card on the right.
export function GrowthCard({ label, series, perWeekLabel }) {
  const delta = series.delta_wk || 0
  const tone = delta >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{label}</p>
      <div className="mt-1 flex items-baseline justify-between">
        <span className="text-2xl font-bold text-gray-900 dark:text-gray-100">{(series.current || 0).toLocaleString()}</span>
        <span className={`text-xs font-medium ${tone}`}>
          {delta > 0 ? "+" : ""}{delta} {perWeekLabel}
        </span>
      </div>
      <div className="mt-3">
        <Sparkbars spark={series.spark} />
      </div>
    </div>
  )
}
